module.exports = __webpack_public_path__ + "right.3cf3c67e.png";